import Big from "big.js";
import store from "../store";
import { labelForCode, codeFromHasTax } from "./taxCatalog";

const SaleItem = class {
    constructor(object) {
        if (object === undefined) {
            this.uid = null;
            this.id = null
            this.code = null
            this.productId = null
            this.product = null;
            this.productObj = null;
            this.hasTax = false;
            this.ivaCode = '0';
            this.iceCode = null;
            this.iceValue = new Big('0.0');
            this.amount = new Big('0.0');
            this.discount = new Big('0.0');
            this.readableDiscount = new Big('0.0');
            this.unitPrice = new Big('0.0');
            this.priceList = [0.0];
            this.isPrintable = false;
            this.observations = null;
            this.cost = null;
            this.createdAt = null;
            this.creditable = null;
        } else {
            this.uid = object.uid || this.makeid(10);
            this.id = object.id || null;
            this.code = object.code || null;
            this.productId = object.productId;
            this.product = object.product;
            this.productObj = object.productObj;
            this.hasTax = object.hasTax;
            this.ivaCode = object.ivaCode || codeFromHasTax(object.hasTax, store.getters.business.taxPercentage);
            // ICE congelado del item (lo calcula el backend desde el producto).
            this.iceCode = object.iceCode || null;
            this.iceValue = (object.iceValue !== undefined && object.iceValue !== null) ? new Big(object.iceValue) : new Big('0.0');
            this.amount = (object.amount !== undefined) ? new Big(object.amount) : new Big('1.0');
            this.discount = (object.discount !== undefined) ? new Big(object.discount) : new Big('0.0');
            this.readableDiscount = this.discount.times(100).round(2);
            this.unitPrice = (object.unitPrice !== undefined) ? new Big(object.unitPrice) : new Big('0.0');
            this.priceList = object.priceList;
            this.isPrintable = object.isPrintable || false;
            this.observations = object.observations || null;
            this.cost = (object.cost !== undefined && object.cost !== null) ? new Big(object.cost) : null;
            this.createdAt = (object.createdAt !== undefined && object.createdAt !== null) ? new Date(object.createdAt) : null;
            // Lo que queda por acreditar de la línea con notas de crédito; solo llega
            // cuando el formulario de N/C lo pide (ver CreditNote.creditableBySaleItem).
            this.creditable = (object.creditable !== undefined && object.creditable !== null) ? new Big(object.creditable) : null;
        }
        this.readableTax = labelForCode(this.ivaCode);
    }

    get totalPrice() {
        return this.unitPrice.times(this.amount).times(this.discount.times(-1).plus(1)).round(2);
    }

    applyDiscount(discount) {
        this.discount = new Big(discount);
        this.totalPrice = this.unitPrice.times(this.amount).times(this.discount.times(-1).plus(1)).round(2);
    }

    makeid(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
}

export default SaleItem